import { NamingSchemeElemenentArg } from 'models/administration'

const isFieldInShortName: (args?: NamingSchemeElemenentArg) => boolean = (args) => args?.inShortName === true

export default isFieldInShortName
